import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Tab, Tabs, Grid, IconButton, ButtonBase, Snackbar, Dialog, Zoom, Box, Paper } from '@material-ui/core';
import HomeList from './Homelist';
import AppUtils from '../../control/apputlis';
import DeviceEventEmitter, { EventName } from '../../control/event';
import TabIndicator from '../view/TabIndicator';
import Apis from '../../network/Apis';
import HomeNews from './HomeNews';
import HomeCircle from './HomeCircle';
import Homeflowlist from './Homeflowlist';
import MSnackbar from '../view/MSnackbar';

import "../../css/home.css";
import AppData from '../../model/AppData';
import IMEventEmitter, { IMEvent } from '../../net/IMEventEmitter';
import Download from './Download';
import ToName from '../../control/ToName';
import Profile from '../../control/Profile'

const SEARCH_ICON = require("../../images/icons/sousuo_icon.png");
const HISTORY_ICON = require("../../images/icons/shangcheng_icon@3x.png");
const ICON1 = require("../../images/icons/gengduo_icon.png");
const ICON_offDialog = require("../../images/icons/closeDialog.png");
const ICON_qd = require("../../images/icons/home_qd.png");
// const showDialogBg = require("../../images/bg/loginDialog.png");


const HOME_TAB_INDEX_KEY = 'HOME_TAB_INDEX_KEY';

class HomePage extends React.Component {
    constructor(props) {
        super(props);
        var tabIndex = AppData.homeTabIndex;

        this.state = {
            tabIndex: tabIndex,
            searchVal: '',
            showDiaLog: false,
            showOtherLogin: false,
            isShowLabel: false,
            offStore: false,
            LIST_CFG: [{ type: 0, flow: false, id: 0, logo: '', name: '推荐', type_id: 1, view: <HomeList type={1} /> },],
        };
        this.getDateDay()

        //禁止页面滚动
        document.body.style.overflow = 'hidden';
    }

    getDateDay = () => {
        let day = AppUtils.getStorageItem('day')
        if (day == null) {
            return
        }

        let date = new Date;
        let d = date.getDay() //今天的日期
        d = d.toString()
        if (d !== day) {
            // this.setState({
            //     isShowLabel: true
            // })
            this.state.isShowLabel = true;
        }


    }

    componentDidMount() {
        //暴露方法给ios
        window.enterRoom = this.enterRoom.bind(this);

        DeviceEventEmitter.on(EventName.HOME_SWIPER_INDEX, this._swiperIndex, this);
        IMEventEmitter.on(IMEvent.S2C_MSG_LOGIN_OTHER_NTY, this.onLoginOtherNty, this);
        IMEventEmitter.on('changeHomeTabIndex', this.changeTabIndex, this);
        AppData.checkUpdate();
        AppUtils.YMPush('MAIN', 'HomePage');




        this.getRecommType();

        let { os, token, uid, fastkey, roomIp, roomPort, customerId, fid } = this.props.match.params;

        if (os && os != null && AppData.os == '') {
            AppData.os = os;
            AppUtils.setStorageItem('uid', uid)
            AppUtils.setStorageItem('fastkey', fastkey)
            AppUtils.setStorageItem('roomIp', roomIp)
            AppUtils.setStorageItem('roomPort', roomPort)
        }
        if (fid && fid != 0) {
            AppData.me.free_id = fid
        }

        if (token && token.length > 6) {
            AppData.me.token = token
        }
        if (customerId && customerId != 0) {
            AppData.me.customer_id = customerId
        }

        if (!AppData.me.isLogin() && AppData.os == '' && !AppData.me.isYk && !AppData.me.isYkLogin()) {
            console.log("登录了");
            AppData.login();
        }

        this.showLoginDIaog()
        this.getServerConfig()
    }

    changeTabIndex = (index) => {
        this.setState({
            tabIndex: index
        })
    }

    componentWillUnmount() {
        DeviceEventEmitter.off(EventName.HOME_SWIPER_INDEX, this._swiperIndex, this);
        IMEventEmitter.off(IMEvent.S2C_MSG_LOGIN_OTHER_NTY, this.onLoginOtherNty, this);
    }

    getServerConfig = async () => {

        let res = await Apis.encryptionServerConfig();
        if (res.code == 200 && res.data) {
            AppData.ServerConfig = res.data
            AppData.app_68 = res.data.app_68
            if (AppData.ServerConfig.shop_open_status == 2) {
                this.setState({
                    offStore: true
                })
            }
        }

    }

    onLoginOtherNty = () => {
        this.setState({ showOtherLogin: true })
    }

    //ios要调用的方法
    enterRoom = (jsonStr) => {
        let data = JSON.parse(jsonStr);
        // this.refs.toast.show(jsonStr);
        this.props.history.push(data);
    }

    //如果没登陆，弹出登陆的Diaog
    showLoginDIaog = () => {
        if (AppData.os !== '') {
            return;
        }
        let token = AppUtils.getStorageItem("user_token");
        if (!token || token.length == 0) {
            if (AppData.fistOpen && !AppData.me.isLogin()) {
                this.setState({
                    showDiaLog: true
                })
            }
        }
        AppData.fistOpen = false;
    }


    closeDialog = () => {
        this.setState({
            showDiaLog: false
        })
    }

    closeOtherDialog = () => {
        this.setState({
            showOtherLogin: false
        })
    }


    pushLogin = () => {
        this.closeDialog()

        setTimeout(() => {
            this.props.history.push({ pathname: '/login' });
        }, 1000 * 1)

    }



    // dialogView = () => {
    //     return (
    //         <Dialog open={this.state.showDiaLog} classes={{}}>
    //             <Box sx={{ display: 'flex' }}>
    //                 <Zoom in={this.state.showDiaLog} style={{ transitionDelay: this.state.showDiaLog ? '1500ms' : '0ms' }}>
    //                     <div className='dialogBox'>
    //                         <img src={showDialogBg} style={{ width: '18rem' }} onClick={() => this.pushLogin()} />
    //                         <img src={ICON_offDialog} style={{ width: 35, height: 35 }} onClick={() => this.closeDialog()} />
    //                     </div>
    //                 </Zoom>
    //             </Box>
    //         </Dialog>
    //     )
    // }

    dialogOther = () => {
        return (
            <Dialog open={this.state.showOtherLogin} classes={{}}>
                <div className='dialogBox'>
                    <div style={{ width: '80vw', height: '20vw', backgroundColor: '#FFF', borderRadius: 10 }}>
                        <div style={{ marginLeft: 12, marginRight: 12, textAlign: 'center', marginTop: 24 }}>
                            <span style={{ color: '#0D0D0D' }}>您的账号已经在其他地方登录，请刷新界面重新登录</span>
                        </div>
                    </div>
                    <img src={ICON_offDialog} style={{ width: 35, height: 35 }} onClick={() => this.closeOtherDialog()} />
                </div>
            </Dialog>
        )
    }

    getRecommType = async () => {

        let data = [];
        let localChannels = AppUtils.getStorageObj(AppUtils.CUSTOM_CHANNELS);
        if (localChannels != null) {
            data = localChannels;
        } else {
            let result = await Apis.encryptionRecommType();
            if (result.code == 200) {
                data = result.data;
                AppUtils.setStorageObj(AppUtils.CUSTOM_CHANNELS, data);
            }
        }

        let LIST_CFG = [];
        LIST_CFG[0] = { type: 0, flow: false, id: 0, logo: '', name: '推荐', type_id: 1, view: <HomeList type={1} /> }
        LIST_CFG[1] = { type: 0, flow: false, id: 0, logo: '', name: '球圈', type_id: 1, view: <HomeCircle type={1} /> }
        LIST_CFG[2] = { type: 0, flow: false, id: 0, logo: '', name: '快讯', type_id: 1, view: <HomeNews type={1} /> }
        for (let i = 0; i < data.length; i++) {
            const element = data[i];
            LIST_CFG[i + 3] = { type: 1, flow: true, name: element.name, id: element.id, type_id: element.id, view: <Homeflowlist type={element.id} /> }
        }
        this.setState({ LIST_CFG: LIST_CFG });

    }

    isWebClip = () => {
        let { os } = this.props.match.params;
        let webclip = AppUtils.getQueryVariable('webclip');
        if (webclip && webclip == 1 || os == "ios" || AppUtils.isWebClip) {
            return true;
        }
        return false;
    }

    _swiperIndex = (result) => {

        this.setState({
            tabIndex: Number(result),
        });
        AppData.homeTabIndex = result
        AppUtils.setStorageItem(HOME_TAB_INDEX_KEY, result);
    }

    onTabChange = (event, newValue) => {
        console.log('onTabChange=', newValue)

        this._swiperIndex(newValue);
        DeviceEventEmitter.emit(EventName.HOME_SWIPER_INDEX, newValue);
    }

    //搜索按钮
    _onSearchClick = (e) => {
        this.props.history.push({ pathname: '/search' });
    }

    _onClickEdit() {
        let os = 0;
        if (AppData.os != '' && AppData.os != 0) {
            os = AppData.os
        }
        ToName(this.props, `/customchannel/${os}`)
    }

    _renderTopTabs = () => {
        const { tabIndex, LIST_CFG } = this.state;

        return (
            <Grid container direction='row' alignItems='center' justifyContent='space-between'>
                <Grid container direction='row' style={{ width: 'calc(100vw - 40px)', flex: 1, marginLeft: 8 }}>
                    <Tabs
                        variant="scrollable"
                        scrollButtons="auto"
                        value={Number(tabIndex)}
                        onChange={(e, value) => this.onTabChange(e, value)}
                        aria-label="simple tabs example"
                        TabIndicatorProps={{ children: <TabIndicator />, style: { backgroundColor: 'transparent', marginBottom: 1.5 } }}
                    >
                        {
                            LIST_CFG.map((item, i) => (
                                <Tab key={i + ''} wrapped={false} label={item.name} style={{ color: tabIndex == i ? '#0D0D0D' : '#ccc', opacity: 1, fontSize: tabIndex == i ? 17 : 14, height: '100%', padding: 0, fontWeight: tabIndex == i ? 'bold' : 'inherit' }}></Tab>
                            ))
                        }
                    </Tabs>
                </Grid>
                <Grid container direction='row' justifyContent="center" style={{ width: 32 }}>
                    <ButtonBase disableRipple onClick={() => this._onClickEdit()}>
                        <img src={ICON1} style={{ width: 15, height: 15 }}></img>
                    </ButtonBase>
                </Grid>

            </Grid>
        )
    }

    tojf = () => {
        if (AppData.me.isLogin()) {

            let os = 0;
            if (AppData.os !== '') {
                os = AppData.os
            }
            let token = 0;

            if (AppData.me.token !== '') {
                token = AppData.me.token
            }

            let customerId = 0
            if (AppData.me.customer_id && AppData.me.customer_id != 0 && AppData.me.customer_id != '') {
                customerId = AppData.me.customer_id
            }
            ToName(this.props, `/integralwallet/${os}/${token}/0/0/0/0/${customerId}`)
        } else {
            ToName(this.props, '/login')
        }
    }

    _renderSearchBar = () => {
        const { classes } = this.props;
        const { searchVal } = this.state;
        return (
            <Grid className={classes.toolBar} direction='row' container alignItems='center'>
                <Grid onClick={() => this._onSearchClick()} className={classes.inputBg} direction='row' container alignItems='center' >
                    <img alt='search' src={SEARCH_ICON} className={classes.toolIcon} style={{ color: '#FFF', marginLeft: 8 }} />
                    {/* <form action="">
                        <input
                            type='text'
                            type="search"
                            onChange={event => this.setState({ searchVal: event.target.value })}
                            value={searchVal}
                            onClick={this._onSearchClick}
                            className={classes.searchInput}
                            placeholder='搜索比赛/联赛/房间号' />
                    </form> */}
                    <div style={{ fontSize: 10, marginLeft: 10, color: '#919191' }} >
                        搜索比赛/联赛/房间号
                    </div>
                </Grid>
                {
                    !this.state.offStore && <div onClick={() => this.tojf()} className={classes.historyBg}>
                        {this.state.isShowLabel && <img src={ICON_qd} className="iconQD" />}
                        <img src={HISTORY_ICON} className={classes.historyIcon} />
                    </div>
                }


            </Grid>
        )
    }


    handleTouchMove = (event) => {
        event.preventDefault();
    };

    render() {
        const { classes } = this.props;
        const { tabIndex, showOtherLogin } = this.state;
        let isWebClip = this.isWebClip();
        let showDownload = Profile.showDownload;
        return (
            <div className="picker-scroller" onTouchMove={() => this.handleTouchMove}>
                <React.Fragment>
                    <div className={classes.topContainer} >
                        <div className={classes.appbar} style={{ position: 'fixed', top: 0, zIndex: 11, }}>
                            {/* <MStatusBar /> */}
                            {this._renderSearchBar()}
                            {this._renderTopTabs()}
                        </div>

                        <div className={classes.pannel} style={{ marginTop: 102 }}>
                            <Grid container className={classes.pannel1}>
                                {tabIndex == 0 && <HomeList key={tabIndex} type={tabIndex} />}
                                {tabIndex == 1 && <HomeCircle key={tabIndex} type={tabIndex} />}
                                {tabIndex == 2 && <HomeNews key={tabIndex} type={tabIndex} />}
                                {(tabIndex != 1 && tabIndex != 0 && tabIndex != 2) && <Homeflowlist key={tabIndex} type={tabIndex} />}
                            </Grid>
                        </div>
                        {/* <div >
                            {this.dialogView()}
                        </div> */}
                        {
                            showOtherLogin && <div>
                                {this.dialogOther()}
                            </div>
                        }
                        {showDownload && <div style={{
                            height: 36,
                            width: '100vw',
                            position: 'fixed',
                            bottom: 56,
                            zIndex: 999
                        }}>
                            {!isWebClip && <Download />}
                        </div>}
                    </div>
                    <MSnackbar ref='toast' />
                </React.Fragment >
            </div>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    appbar: {
        width: '100vw',
        backgroundSize: '100% 100%',
        // background: 'linear-gradient(90deg, #0C3ABD 100%, #136DDD 100%)',
        backgroundColor: '#fff',
        backgroundRepeat: 'no-repeat',
    },
    topContainer: {
        width: '100vw',
        backgroundColor: '#EFEFF4',
    },
    searchInput: {
        flex: 1,
        width: '100%',
        margin: theme.spacing(0, 0, 0, 1),
        backgroundColor: 'transparent',
        justifyContent: 'center',
        border: 'none',
        outline: 'none',
        color: '#3A445F',
        fontSize: theme.typography.pxToRem(11),
    },
    toolBar: {
        width: '100vw',
        padding: theme.spacing(2, 1, 1, 1),
    },
    historyBg: {
        position: 'relative',
        padding: 0,
        display: 'flex',
        justifyCcontent: 'center',
        alignTtems: 'center',
    },
    bbq: {
        width: 66,
        height: 19,
        marginLeft: theme.spacing(2),
        zIndex: 1001,
    },
    historyIcon: {
        width: 25,
        height: 25,
        marginLeft: 5
    },
    toolIcon: {
        width: 16,
        height: 16,
    },
    pannel: {
        width: '100vw',
        height: '100vh',
        display: 'flex',
        padding: theme.spacing(0, 0, 0, 0),
    },
    inputBg: {
        background: '#F3F3F3',
        // background: 'rgba(255,255,255,0.1)',
        height: theme.typography.pxToRem(30),
        borderRadius: theme.typography.pxToRem(13.5),
        marginRight: theme.spacing(1),
        flex: 1,
        padding: theme.spacing(0, 1, 0, 1),
    },
    pannel1: {
        width: '100vw',
        flexDirection: 'column',
        padding: theme.spacing(0, 0, 0, 0),
        height: '100%'
    },
}))(HomePage));